var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center text-dark my-5"},[_c('b-spinner',{staticClass:"align-middle"}),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"margin":"8px 0"}},[_c('strong',[_vm._v("Loading...")])])
}]

export { render, staticRenderFns }